import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { SEMANTICS, SEMANTICS_LABEL, semanticsOf } from "@/lib/testSemantics";

// Semantica = configurazione metodologica del test (Libreria). Non modificabile in Registrazione.
export default function SemanticsEditor({ test, canEdit, onSaved }) {
  const cur = semanticsOf(test);
  const [editing, setEditing] = useState(false);
  const [sem, setSem] = useState(cur);
  const [rule, setRule] = useState({ min: test.semantics_rule?.min ?? "", max: test.semantics_rule?.max ?? "" });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const body = { semantics: sem, rule: sem === "TARGET_RANGE" ? { min: rule.min === "" ? null : parseFloat(rule.min), max: rule.max === "" ? null : parseFloat(rule.max) } : null };
      await api.put(`/tests/${test.id}/semantics`, body);
      toast.success(`Semantica: ${SEMANTICS_LABEL[sem]}`);
      setEditing(false); onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
    finally { setBusy(false); }
  };

  const tone = cur === "UNDEFINED" ? "bg-amber-50 text-amber-800 border-amber-200" : cur === "DESCRIPTIVE_ONLY" ? "bg-zinc-100 text-zinc-600 border-zinc-200" : "bg-emerald-50 text-emerald-800 border-emerald-200";

  if (!editing) {
    return (
      <div className="mt-1.5 flex items-center gap-2 flex-wrap">
        <span data-testid={`semantics-badge-${test.id}`} className={`text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded border ${tone}`}>{SEMANTICS_LABEL[cur]}{cur === "TARGET_RANGE" && test.semantics_rule?.min != null ? ` ${test.semantics_rule.min}–${test.semantics_rule.max}` : ""}</span>
        {canEdit && <button data-testid={`semantics-edit-${test.id}`} onClick={() => setEditing(true)} className="text-[10px] text-[#0052FF] hover:underline">modifica</button>}
        {test.semantics_updated_by && test.semantics_source === "direzione_tecnica" && <span className="text-[9px] text-zinc-400 font-mono">DT · {test.semantics_updated_at?.slice(0, 10)}</span>}
      </div>
    );
  }
  return (
    <div className="mt-1.5 space-y-1.5" data-testid={`semantics-editor-${test.id}`}>
      <select data-testid={`semantics-select-${test.id}`} className="h-8 w-full border border-zinc-200 rounded text-xs px-1" value={sem} onChange={(e) => setSem(e.target.value)}>
        {SEMANTICS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {sem === "TARGET_RANGE" && (
        <div className="flex items-center gap-1 text-xs">
          <Input data-testid={`semantics-min-${test.id}`} type="number" className="h-7 text-xs font-mono" placeholder="min (opz.)" value={rule.min} onChange={(e) => setRule({ ...rule, min: e.target.value })} />
          <span className="text-zinc-400">–</span>
          <Input data-testid={`semantics-max-${test.id}`} type="number" className="h-7 text-xs font-mono" placeholder="max (opz.)" value={rule.max} onChange={(e) => setRule({ ...rule, max: e.target.value })} />
        </div>
      )}
      <div className="flex gap-2 text-[10px]">
        <button data-testid={`semantics-save-${test.id}`} disabled={busy} onClick={save} className="px-2 py-1 bg-black text-white rounded">Salva</button>
        <button onClick={() => { setEditing(false); setSem(cur); }} className="px-2 py-1 border border-zinc-200 rounded">Annulla</button>
      </div>
    </div>
  );
}
